import { templateDummy } from ".";

const validateTemplate = (nftTemplates) => {
	console.log(nftTemplates);
	if (Object.keys(nftTemplates).length === 0) {
		return "empty";
	}
	const templateWithMissings = [];
	Object.keys(nftTemplates).forEach((e) => {
		const missings = Object.keys(nftTemplates[e]).map((e_) => {
			if (e_ !== "type") return nftTemplates[e][e_] === templateDummy[e_];
		});
		if (missings.some((e_) => e_ === true)) templateWithMissings.push(e);
	});
	return templateWithMissings;
};

export default validateTemplate;
